import { AsYouType, type MuiTelInputCountry } from 'mui-tel-input';

export const DEFAULT_PHONE_COUNTRY: MuiTelInputCountry = 'RO';

export function isPhoneNumberIncomplete(value?: string | null): boolean {
  if (!value?.trim()) {
    return true;
  }

  const formatter = new AsYouType();
  formatter.input(value);
  return !formatter.getNationalNumber();
}

export function phoneCountryToPreselect(
  addressCountry: string | null | undefined,
  phoneNumber: string | null | undefined,
): MuiTelInputCountry | undefined {
  if (!addressCountry) {
    return undefined;
  }
  if (!isPhoneNumberIncomplete(phoneNumber)) {
    return undefined;
  }
  return addressCountry as MuiTelInputCountry;
}
